export { default } from './Container/ModalComponent';
